<template>
  <main class="main main--services services">
    <div>
      <div class="group group--last" ref="main">
        <div class="services__grid">
          <div class="services__heading">
            <h1 
              :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
              class="h1">{{ service.intro.heading }}</h1>
            <p 
              class="small"
              v-for="(p, index) in service.intro.copy"
              :key="`introCopy${index}`"
              v-html="p"
            />
          </div>
          <div class="services__cta">
            <h2 
              v-if="service.cta.number" 
              :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
              class="h2 mb0">Call <a class="tdn" :href="`tel:${service.cta.number}`">{{ service.cta.number | phone }}</a></h2>
            <p v-if="service.cta.number" class="p mt0 small" v-html="service.cta.copy" />
            <div v-if="service.cta.buttons">
              <module-button
                v-for="(button, index) in service.cta.buttons"
                :key="`extraInfoButton${index}`"
                v-bind="button"
                @click.native="getServiceProviders(button.action)"
               
              />
            </div>
            <hr>
          </div>
          <div
            v-if="service.extraInfo"
            class="services__extra"
          >
            <div
              v-for="(section, index) in service.extraInfo"
              :key="`extraInfo${index}`"
            >
              <h2 
                :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                class="h2 mt0">{{ section.heading }}</h2>
              <p 
                class="small"
                v-for="(p, index) in section.copy"
                :key="`extraInfoCopy${index}`"
                v-html="p"
              />
             
              <div v-if="section.buttons">
                <module-button
                  v-for="(button, index) in section.buttons"

                  :key="`extraInfoButton${index}`"

                  v-bind="button"
                />
              </div>
            </div>
            <hr>
          </div>
          <div
            :class="[
              `services__icon-list`,
              {
                'services__icon-list--legal': isLegal
              }
            ]"
          >
            <module-info-list :sections="service.iconList" />
          </div>

          <div class="services__help-list">
            <hr>
            <h2 
              :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
              class="h2 mt0">We can help you with</h2>
            <module-help-list :items="service.helpList" />
          </div>

          <div class="services__image">
            <img
              :src="service.image"
              alt=""

              :class="[
                'services__img',
                {
                  'services__img--fixed' : fixImage,
                  'services__img--finance' : isFinance,
                }
              ]"

              :style="{
                maxWidth: `${imageSize}vw`,
                top: `${offsetTop}px`
              }"
            >
          </div>
        </div>
      </div>

    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Utils
import { arrayLoop } from 'utils/array';
import phone from 'utils/phone';

// Modules
import ModuleInfoList from 'components/InfoList';
import ModuleHelpList from 'components/HelpList';

// Models
import { legal }  from 'models/services/legal';
import { financial } from 'models/services/financial';
import { family } from 'models/services/family';


// Export
export default {
  name: 'view-legal',

  // Components
  components: {
    ModuleInfoList,
    ModuleHelpList,
  },

  filters: {
    phone,
  },

  data() {
    return {
      services: {
        legal,
        financial,
        family,
      },
      fixImage: false,
      lastScroll: 0,
      imageSize: (100 / 18) * 6,
      offsetTop: 250,
    };
  },

  // Computed
  computed: {
    ...mapGetters('app', [
      'org',
    ]),
    service() {
      let currentService;
      arrayLoop(this.services, (key, value) => {
        if(this.$route.name === key) return currentService = value;
      });
      return currentService;
    },
    isLegal() {
      return this.$route.name === 'legal';
    },
    isFinance() {
      return this.$route.name === 'financial';
    },
  },

  // Methods
  methods: {
    ...mapActions('app',[ 'requestServiceLinks']),
    onBodyScroll() {
      const currentScroll = window.scrollY;
      const maxScroll = 300;
      const maxTop = 250;
      const minTop = 75;

      const topDiff = maxTop - minTop;

      const pixelsPerScrollTop = ( topDiff / maxScroll);

      const scrollPosition = Math.min(currentScroll, maxScroll);

     
      const changeTop = scrollPosition * pixelsPerScrollTop;

      if (window.innerWidth >= 1080) {

        if(currentScroll > this.lastScroll) {

         
          this.offsetTop = maxTop - changeTop;

          this.lastScroll = currentScroll;

          if (currentScroll > 140 ) {
            this.fixImage = true;
          }
        }

        else if (currentScroll > maxScroll) {
          
          this.offsetTop = maxTop;
        }

        else if (currentScroll < this.lastScroll && currentScroll < maxScroll ) {
          this.lastScroll = currentScroll;
         
          this.offsetTop = maxTop - changeTop;
        }
      }
    },

    getServiceProviders(action) {
      if(action === 'searchServices') {
        _.forEach(this.org.homepage_navs, nav => { // eslint-disable-line no-undef
          if( nav.url === this.$router.currentRoute.path) {
            this.requestServiceLinks(nav.id)
              .then(() =>  {
                this.$router.push({ path: 'search-services' });
              });
            return;
          }
        });
      }
    },
  },

  // Created
  created () {
    window.addEventListener('scroll', this.onBodyScroll);
  },

  // Destroyed
  destroyed () {
    window.removeEventListener('scroll', this.onBodyScroll);
  },
};
</script>



// WEBPACK FOOTER //
// Services.vue?a3122b10